export const LuxLogoWhite = "https://res.cloudinary.com/dqe7trput/image/upload/v1724846628/Horizontal_-_White0_2_haq83u.svg"
export const reportPaymentValue = "11.99"
